import { render, staticRenderFns } from "./PtReport.vue?vue&type=template&id=23ef7522&scoped=true&"
import script from "./PtReport.vue?vue&type=script&lang=js&"
export * from "./PtReport.vue?vue&type=script&lang=js&"
import style0 from "./PtReport.vue?vue&type=style&index=0&id=23ef7522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef7522",
  null
  
)

export default component.exports